import { render, staticRenderFns } from "./SendGrid.vue?vue&type=template&id=659d2c2b"
import script from "./SendGrid.vue?vue&type=script&lang=js"
export * from "./SendGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports